// extracted by mini-css-extract-plugin
export default {"logoMobile":"Header_logoMobile__MXgTS","logoDesktop":"Header_logoDesktop__Xh2tA"};